import {
  LEAVEREQUEST_ALL,
  LEAVEREQUEST_GET,
  LEAVEREQUEST_PUT,
  LEAVEREQUEST_DEL,
  LEAVEREQUEST_POST,
  LEAVEREQUEST_LOADING,
  LEAVEREQUEST_ERROR,
  LEAVEREQUEST_PENDING_COUNT,
} from '../../actions/types';

const initialState = {
  leaveRequest: null,
  isLoading: true,
  isCompleted: true,
  pendingCount: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LEAVEREQUEST_LOADING:
      return { isLoading: true, isCompleted: true, pendingCount: state.pendingCount };
    case LEAVEREQUEST_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload, pendingCount: state.pendingCount };
    case LEAVEREQUEST_ALL:
      return { ...action.payload, isLoading: false, isCompleted: true, pendingCount: state.pendingCount };
    case LEAVEREQUEST_GET:
      return { ...action.payload, isLoading: false, isCompleted: true, pendingCount: state.pendingCount };
    case LEAVEREQUEST_POST:
      return { isLoading: false, isCompleted: true, pendingCount: state.pendingCount };
    case LEAVEREQUEST_PUT:
      return { isLoading: false, isCompleted: true, pendingCount: state.pendingCount };
    case LEAVEREQUEST_DEL:
      return { isLoading: false, isCompleted: true, pendingCount: state.pendingCount };
    case LEAVEREQUEST_PENDING_COUNT:
      return { ...state, pendingCount: action.payload };
    default:
      return state;
  }
}
